export function InputValidation({ schema, formdata }) {

  const FIRST_ERROR = 0;

  return schema.validate(formdata, { abortEarly: false }).catch(function (err) {

    const getValidation = (type) => {
      const errors = {
        required: () => "Campo obrigatório!",
        email: () => "Formato de e-mail inválido!",
        matches: () => "Preenchimento inválido!",
        typeError: () => "Preenchimento inválido!"
      }
      return errors[type] ? errors[type]() : err.errors[FIRST_ERROR];
    }

    const NAME_ERROR = err.inner.map((e) => { return e.path })

    const TYPE_ERROR = err.inner.map((e) => { return getValidation(e.type) })

    return {
      error: TYPE_ERROR,
      id: NAME_ERROR
    }
  })
}
